import { render, staticRenderFns } from "./receiveDialog.vue?vue&type=template&id=5eda6df9&scoped=true"
import script from "./receiveDialog.vue?vue&type=script&lang=js"
export * from "./receiveDialog.vue?vue&type=script&lang=js"
import style0 from "./receiveDialog.vue?vue&type=style&index=0&id=5eda6df9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eda6df9",
  null
  
)

export default component.exports